import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid
} from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'
import EmailInformationFields from './EmailInformationFields'
import SenderInformationFields from './SenderInformationFields'
import ReceiverInformationFields from './ReceiverInformationFields'

const ManualConfigurationSection = ({
  control,
  errors,
  isPasswordShown,
  onTogglePassword
}) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ mt: 3 }}>
      <Card variant="outlined" sx={{
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: 3,
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
      }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ mb: 10, textAlign: 'center' }}>
            <SettingsIcon sx={{
              fontSize: 48,
              color: 'primary.main',
              mb: 2,
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
            }}/>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
              {t('mailTemplate.users.modal.manualConfiguration')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400, mx: 'auto' }}>
              {t('mailTemplate.users.modal.manualConfigurationDescription')}
            </Typography>
          </Box>

          <Grid container spacing={6}>
            <Grid item xs={12} md={4}>
              <EmailInformationFields
                control={control}
                errors={errors}
                isPasswordShown={isPasswordShown}
                onTogglePassword={onTogglePassword}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <SenderInformationFields
                control={control}
                errors={errors}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <ReceiverInformationFields
                control={control}
                errors={errors}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}

export default ManualConfigurationSection
